import { create } from 'zustand';
import api from '../services/api';
import { toast } from 'react-toastify';

export const useTicketStore = create((set, get) => ({
  tickets: [],
  currentTicket: null,
  loading: false,

  fetchTickets: async (params = {}) => {
    set({ loading: true });
    try {
      const query = new URLSearchParams(params).toString();
      const res = await api.get(`/tickets${query ? '?' + query : ''}`);
      set({ tickets: res.data.tickets, loading: false });
    } catch (error) {
      set({ loading: false });
      toast.error('Failed to fetch tickets');
    }
  },

  fetchTicket: async (id) => {
    set({ loading: true });
    try {
      const res = await api.get(`/tickets/${id}`);
      set({ currentTicket: res.data.ticket, loading: false });
      return res.data.ticket;
    } catch (error) {
      set({ loading: false });
      toast.error('Failed to fetch ticket');
      return null;
    }
  },

  createTicket: async (data) => {
    try {
      const res = await api.post('/tickets', data);
      set(state => ({ tickets: [res.data.ticket, ...state.tickets] }));
      toast.success(`Ticket ${res.data.ticket.ticketNumber} created!`);
      return res.data.ticket;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to create ticket');
      return null;
    }
  },

  updateStatus: async (id, status) => {
    try {
      const res = await api.put(`/tickets/${id}/status`, { status });
      set(state => ({
        tickets: state.tickets.map(t => t._id === id ? res.data.ticket : t),
        currentTicket: state.currentTicket?._id === id ? res.data.ticket : state.currentTicket
      }));
      toast.success('Status updated');
      return res.data.ticket;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update status');
      return null;
    }
  },

  assignTicket: async (id, userId) => {
    try {
      const res = await api.put(`/tickets/${id}/assign`, { userId });
      set(state => ({
        tickets: state.tickets.map(t => t._id === id ? res.data.ticket : t),
        currentTicket: state.currentTicket?._id === id ? res.data.ticket : state.currentTicket
      }));
      toast.success('Ticket assigned');
      return res.data.ticket;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to assign ticket');
      return null;
    }
  },

  addComment: async (id, content) => {
    try {
      const res = await api.post(`/tickets/${id}/comments`, { content });
      set(state => ({
        currentTicket: state.currentTicket?._id === id ? res.data.ticket : state.currentTicket
      }));
      return res.data.ticket;
    } catch (error) {
      toast.error('Failed to add comment');
      return null;
    }
  }
}));
